import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
    Sev2ProjectCombobox,
    Sev2ProjectComboboxSchema,
} from './Sev2ProjectCombobox';

export const Sev2ProjectComboboxFieldExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'Sev2ProjectCombobox',
        component: Sev2ProjectCombobox,
        schema: Sev2ProjectComboboxSchema as CustomFieldExtensionSchema,
    }),
);
